export default __webpack_public_path__ + "static/media/sidebar_salesorder_blue.00243d05.svg";